export const i18_TRANSLATION = 'TRANSLATION'
export const i18_EDITTERMIN = 'TERMIN'
export const i18_LIST = 'LIST'
export const i18_LISTDOC = 'LIST_DOC'
export const i18_MESSAGE = 'MESSAGE'
export const i18_ARTIST = 'ARTIST'
export const i18_TEMPLATES = 'TEMPLATES'
export const i18_KISSSIGN = 'KISS_SIGN'
export const i18_NACHRICHT = 'NACHRICHT'
export const i18_STUDIO = 'STUDIO'
export const i18_KUNDE = 'KUNDE'
export const i18_EDITPROJEKT = "PROJECT"
export const i18_ICAL_IMPORT = "ICALIMPORT"
export const i18_EINNAHMEN = 'EINNAHMEN'
export const i18_TIMELINE = 'TIMELINE'
export const i18_CUSTOMER_PORTAL = 'CUSTOMER_PORTAL'
export const i18_FINALIZER = 'FINALIZER'
export const i18_SIGNUP = 'SIGNUP'
export const i18_ANALYTICS = 'ANALYTICS'
export const i18_VOUCHERS = 'VOUCHERS'
